import React, {useEffect, useState} from 'react'

//Node Modules
import axios from 'axios'
import { 
  useLocation
} from 'react-router-dom'
import { changeLanguage } from 'i18n'
import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'

//Components
import DownloadContainer from 'components/Download'
import Footer from 'components/Footer'

//Context
import { LanguageContext } from 'context/language-context'
import { ToggleSecureContext } from 'context/content-context'

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const DownloadPage = () => {
  const location = useLocation()
  const softwareId = useQuery().get('softwareId') || undefined
  const softwareVersion = useQuery().get('softwareVersion') || undefined
  const softwareSpecialConfig = useQuery().get('softwareSpecialConfig') ||undefined
  const lang = useQuery().get('locale') || 'en'
  const inapp = useQuery().get('requestor') === 'inapp' ? true : false
  const [secureToggled, setSecureToggled] = useState(false)

  function toggleSecure() {
    setSecureToggled(!secureToggled)
  }

  useEffect( ()=> {
    let params = new URLSearchParams(location.search);
    params.delete('requestor');
    window.history.replaceState({}, '', './download?'+params.toString())
  },[]) /* eslint-disable-line */

  useEffect(() => {
    changeLanguage(lang)    
  }, [lang])
  
  useEffect(() => {
    const url = `${location.pathname}${location.search}`

    ReactGA.pageview(url)
    ReactGA4.send(url)
  }, [location])

  axios.defaults.headers.common['Accept-Language'] = lang

  return (
    <LanguageContext.Provider value={lang}>
      <ToggleSecureContext.Provider value={{secureToggled, toggleSecure}}>
        <DownloadContainer softwareId={softwareId} softwareVersion={softwareVersion} softwareSpecialConfig={softwareSpecialConfig} inapp={inapp} />
        <Footer />
      </ToggleSecureContext.Provider>
    </LanguageContext.Provider>
  ) 
}
export default DownloadPage